// Immutable snapshot of approved web and desktop artwork.
export const manifest = {
  "schemaVersion": 1,
  "snapshotVersion": "2026-10-02.1",
  "origin": "https://storage.googleapis.com/mario-kart-graphics/",
  "assets": [
    {
      "id": "cc_icons/100cc.png",
      "object": "cc_icons/100cc.png",
      "generation": "1702951103831632",
      "width": 275,
      "height": 48,
      "contentType": "image/png",
      "bytes": 4204,
      "sha256": "ddba5377eb7c84ea06d877212e403442baee42e632b3762c25d0f4894bd61191",
      "label": "100cc",
      "bundledPath": "cc_icons/100cc.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "cc_icons/150cc.png",
      "object": "cc_icons/150cc.png",
      "generation": "1702951104302628",
      "width": 275,
      "height": 48,
      "contentType": "image/png",
      "bytes": 4314,
      "sha256": "fc884c5a6b10f94559cfbeab01ea52b378ebdc3ae869eb29e8d62049f48f308e",
      "label": "150cc",
      "bundledPath": "cc_icons/150cc.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "cc_icons/50cc.png",
      "object": "cc_icons/50cc.png",
      "generation": "1702951103864763",
      "width": 275,
      "height": 48,
      "contentType": "image/png",
      "bytes": 4206,
      "sha256": "798f8b88210a3d1b066eb62cf1a9f01f8e3ce3b9d5eba53cdd2ebcec674d2241",
      "label": "50cc",
      "bundledPath": "cc_icons/50cc.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "cc_icons/Extra.png",
      "object": "cc_icons/Extra.png",
      "generation": "1702951104253607",
      "width": 275,
      "height": 48,
      "contentType": "image/png",
      "bytes": 4585,
      "sha256": "06e79bc43fa00256d4034ddc233fa4060b3472aeb95092f3991247f7d0afc84c",
      "label": "Extra",
      "bundledPath": "cc_icons/Extra.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "cc_icons/SelectCC.png",
      "object": "cc_icons/SelectCC.png",
      "generation": "1705623719695044",
      "width": 275,
      "height": 48,
      "contentType": "image/png",
      "bytes": 4462,
      "sha256": "6d7ab5a8b9496dc0abff054109a73bd03c867c42a21c83a45df678e6b29b641b",
      "label": "SelectCC",
      "bundledPath": "cc_icons/SelectCC.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "char_gifs/misc/DK_8bit.gif",
      "object": "char_gifs/misc/DK_8bit.gif",
      "generation": "1702951123042157",
      "width": 500,
      "height": 350,
      "contentType": "image/gif",
      "bytes": 28823,
      "sha256": "0a20fd710a24f072554cdd4b3bff3bedbf4d21f5219ae85b4fd652b2c99f52ee",
      "label": "DK 8bit",
      "bundledPath": "char_gifs/misc/DK_8bit.gif",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "char_gifs/misc/lakitu_reverse.webp",
      "object": "char_gifs/misc/lakitu_reverse.webp",
      "generation": "1702951123433101",
      "width": 500,
      "height": 270,
      "contentType": "image/webp",
      "bytes": 40466,
      "sha256": "c99de8f30c6b20c5751ab4e2dbb63269783da3406634c1eff538621c00d8117e",
      "label": "lakitu reverse",
      "bundledPath": "char_gifs/misc/lakitu_reverse.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "char_gifs/misc/shells.gif",
      "object": "char_gifs/misc/shells.gif",
      "generation": "1702951123027486",
      "width": 500,
      "height": 160,
      "contentType": "image/gif",
      "bytes": 25266,
      "sha256": "db64a6b732c70f763e9d794bf25d0c4f2c1412934d781ea3ae4219c6a01acdd1",
      "label": "shells",
      "bundledPath": "char_gifs/misc/shells.gif",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/Beeg_Yoshi.png",
      "object": "character_portraits/Beeg_Yoshi.png",
      "generation": "1707190036066100",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 17650,
      "sha256": "1974bb40ae404704c8bb96dfffd10c0bec0414cb8e2635f6468f92d568ab311d",
      "label": "Beeg Yoshi",
      "bundledPath": "character_portraits/Beeg_Yoshi.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/Bowser_portrait.png",
      "object": "character_portraits/Bowser_portrait.png",
      "generation": "1702951106957571",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 24879,
      "sha256": "b3512b3bc3a0c02b174180346635621cb0723992df8528e30a7f20f72bbe008d",
      "label": "Bowser portrait",
      "bundledPath": "character_portraits/Bowser_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/DK_portrait.png",
      "object": "character_portraits/DK_portrait.png",
      "generation": "1702951106291010",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 19222,
      "sha256": "19d10c3f50ba5882714fab390cbae799b5a9d1621bae759fbe9797e183cba4fb",
      "label": "DK portrait",
      "bundledPath": "character_portraits/DK_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/Luigi_portrait.png",
      "object": "character_portraits/Luigi_portrait.png",
      "generation": "1702951106370838",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 16936,
      "sha256": "a5ffe91f6d94319f25a75c2ec531cf0558eae0a391a3762e3ae8c12684aa0609",
      "label": "Luigi portrait",
      "bundledPath": "character_portraits/Luigi_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/Mario_portrait.png",
      "object": "character_portraits/Mario_portrait.png",
      "generation": "1702951105713158",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 17206,
      "sha256": "a0fe40d195634cdf120eed1bb035037ba38e86db5b6aa5fe4d1c81e52ed5514e",
      "label": "Mario portrait",
      "bundledPath": "character_portraits/Mario_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/Peach_portrait.png",
      "object": "character_portraits/Peach_portrait.png",
      "generation": "1702951106370278",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 19618,
      "sha256": "fd6d8337843f158f8d7625580502adbbf41acfab90e5c566e58532d9a1266bdb",
      "label": "Peach portrait",
      "bundledPath": "character_portraits/Peach_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/Toad_portrait.png",
      "object": "character_portraits/Toad_portrait.png",
      "generation": "1702951105753241",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 13274,
      "sha256": "8060e12092b9338dd454608fe65b77b4f4010729c97563e22d68dd960e5f215d",
      "label": "Toad portrait",
      "bundledPath": "character_portraits/Toad_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/Wario_portrait.png",
      "object": "character_portraits/Wario_portrait.png",
      "generation": "1702951105723707",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 23768,
      "sha256": "2b64bb1dcd1b271c5945638d7dba028dc127a3e2ab53878ff6dbe992c3523da7",
      "label": "Wario portrait",
      "bundledPath": "character_portraits/Wario_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "character_portraits/Yoshi_portrait.png",
      "object": "character_portraits/Yoshi_portrait.png",
      "generation": "1702951106854666",
      "width": 128,
      "height": 128,
      "contentType": "image/png",
      "bytes": 14025,
      "sha256": "5a2d4ea46ff01e2cf319d68c0a79be127d5d9a6d632d3002bd3814fcf25666e0",
      "label": "Yoshi portrait",
      "bundledPath": "character_portraits/Yoshi_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "cups/active/FlowerCup.png",
      "object": "cups/active/FlowerCup.png",
      "generation": "1729558721837727",
      "width": 63,
      "height": 38,
      "contentType": "image/png",
      "bytes": 1663,
      "sha256": "2c23c8e1644baa90de30431f8cf90030fd3937b36da848f24a11064df5610750",
      "label": "FlowerCup",
      "bundledPath": "cups/active/FlowerCup.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "cups/active/MushroomCup.png",
      "object": "cups/active/MushroomCup.png",
      "generation": "1729558721839443",
      "width": 63,
      "height": 38,
      "contentType": "image/png",
      "bytes": 1591,
      "sha256": "88c60fc04939c501ad18079a6a9770fd462d3cffa685e148acf4e1a72c92300b",
      "label": "MushroomCup",
      "bundledPath": "cups/active/MushroomCup.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "cups/active/SpecialCup.png",
      "object": "cups/active/SpecialCup.png",
      "generation": "1729558721911371",
      "width": 63,
      "height": 38,
      "contentType": "image/png",
      "bytes": 1702,
      "sha256": "563b6208bd6ea56d54deb30405ecfac12eb38bb1a59ccad62fbf0fa6299ab5d2",
      "label": "SpecialCup",
      "bundledPath": "cups/active/SpecialCup.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "cups/active/StarCup.png",
      "object": "cups/active/StarCup.png",
      "generation": "1729558722179655",
      "width": 63,
      "height": 38,
      "contentType": "image/png",
      "bytes": 1444,
      "sha256": "7e432ab9dad6939414ea121d8227c4e81e60f90cb730f6328f67e4a0fd3957db",
      "label": "StarCup",
      "bundledPath": "cups/active/StarCup.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "game_modes/Hardcore.png",
      "object": "game_modes/Hardcore.png",
      "generation": "1705634355210163",
      "width": 320,
      "height": 48,
      "contentType": "image/png",
      "bytes": 5595,
      "sha256": "412c351a73c1c17db75d44d8a13a3b76ab800bc29632748973a7ae2ab067a866",
      "label": "Hardcore",
      "bundledPath": "game_modes/Hardcore.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "game_modes/Normal.png",
      "object": "game_modes/Normal.png",
      "generation": "1705634355169249",
      "width": 320,
      "height": 48,
      "contentType": "image/png",
      "bytes": 6027,
      "sha256": "db207d5fc2d2a5e379407ff6b8270f3d9d15f14fb73e5bb083e11b51b21ffb27",
      "label": "Normal",
      "bundledPath": "game_modes/Normal.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "game_modes/SelectMode.png",
      "object": "game_modes/SelectMode.png",
      "generation": "1705634355237155",
      "width": 320,
      "height": 48,
      "contentType": "image/png",
      "bytes": 6308,
      "sha256": "fa0b3997eda01d3d7beda9fc67674f770a1d34436ebbb1954fd8879279be3b18",
      "label": "SelectMode",
      "bundledPath": "game_modes/SelectMode.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "headers/ASXMarioKart.png",
      "object": "headers/ASXMarioKart.png",
      "generation": "1702951109461630",
      "width": 2718,
      "height": 1412,
      "contentType": "image/png",
      "bytes": 517988,
      "sha256": "e3dddb61f9d72e06f04a0c83505d8034425c5085d702a1352db42718485b8026",
      "label": "ASXMarioKart",
      "bundledPath": "headers/ASXMarioKart.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "headers/AddPlayer.png",
      "object": "headers/AddPlayer.png",
      "generation": "1702951110546375",
      "width": 696,
      "height": 100,
      "contentType": "image/png",
      "bytes": 26377,
      "sha256": "713f6f1a4afaafef12339089f81a8b43e6aa54efdda7e020e9fe31b5956a375e",
      "label": "AddPlayer",
      "bundledPath": "headers/AddPlayer.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "headers/GrandPrix.png",
      "object": "headers/GrandPrix.png",
      "generation": "1702951110462742",
      "width": 647,
      "height": 100,
      "contentType": "image/png",
      "bytes": 28646,
      "sha256": "bdc44f1ce710018c7c156ec739bf565e86d0fb341fb9d7849c1fd6b74400aa1b",
      "label": "GrandPrix",
      "bundledPath": "headers/GrandPrix.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "headers/RaceEntry.png",
      "object": "headers/RaceEntry.png",
      "generation": "1702951109971757",
      "width": 687,
      "height": 100,
      "contentType": "image/png",
      "bytes": 30112,
      "sha256": "c3cf56922aab8b5c94bffcf81bc6095a9d1de9aa1d4d1ef24f2b56704f28d8cd",
      "label": "RaceEntry",
      "bundledPath": "headers/RaceEntry.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "headers/Roster.png",
      "object": "headers/Roster.png",
      "generation": "1705715372795079",
      "width": 452,
      "height": 100,
      "contentType": "image/png",
      "bytes": 20709,
      "sha256": "ab31a283a66bb8b2128f710d33f7a6133b0c5c8e23f427d11e83a6650924401f",
      "label": "Roster",
      "bundledPath": "headers/Roster.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "headers/SoLongGayBowser.png",
      "object": "headers/SoLongGayBowser.png",
      "generation": "1702951111007213",
      "width": 1000,
      "height": 286,
      "contentType": "image/png",
      "bytes": 65271,
      "sha256": "20237c22e132a60861e8e67762f1830f5e150f585cfaea773c6e52126399f250",
      "label": "SoLongGayBowser",
      "bundledPath": "headers/SoLongGayBowser.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "headers/Standings.png",
      "object": "headers/Standings.png",
      "generation": "1730576331148030",
      "width": 1024,
      "height": 305,
      "contentType": "image/png",
      "bytes": 78557,
      "sha256": "45191d1abd6885aaa9c431fca2979741cd23516c43a1e6b40e26787f10fb07eb",
      "label": "Standings",
      "bundledPath": "headers/Standings.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "headers/Stats.png",
      "object": "headers/Stats.png",
      "generation": "1702951109938332",
      "width": 386,
      "height": 100,
      "contentType": "image/png",
      "bytes": 18095,
      "sha256": "e193e7e24ab7ab8642dc8481c1ff7b94545483f2b297bb618a002bfb00b17dbd",
      "label": "Stats",
      "bundledPath": "headers/Stats.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/BansheeBoardwalk.png",
      "object": "map_names/BansheeBoardwalk.png",
      "generation": "1702951111584068",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 9382,
      "sha256": "09f029a13996b21db3db8046a9fa2e8b7ec5893d8d7411214e466f6a6eca4962",
      "label": "BansheeBoardwalk",
      "bundledPath": "map_names/BansheeBoardwalk.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/BowsersCastle.png",
      "object": "map_names/BowsersCastle.png",
      "generation": "1702951112598244",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7771,
      "sha256": "e38e5ee484550bc5dd8521453138a3a5f467fef05b8f4c505eb3657189e4a74e",
      "label": "BowsersCastle",
      "bundledPath": "map_names/BowsersCastle.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/ChocoMountain.png",
      "object": "map_names/ChocoMountain.png",
      "generation": "1702951113090336",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7415,
      "sha256": "fd29ed2155ecdf968e55e436d1718cd50e57f4dd283b85dc6ef836df656caaed",
      "label": "ChocoMountain",
      "bundledPath": "map_names/ChocoMountain.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/DKsJungleParkway.png",
      "object": "map_names/DKsJungleParkway.png",
      "generation": "1702951113116171",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 9654,
      "sha256": "e9a27a17b9d27b11607d4f144dd3069e0a92aecd4ae25e7fd10dc0220c5f18bc",
      "label": "DKsJungleParkway",
      "bundledPath": "map_names/DKsJungleParkway.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/FrappeSnowland.png",
      "object": "map_names/FrappeSnowland.png",
      "generation": "1702951113586274",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 8219,
      "sha256": "9da95e6e6d0aeb6107a60c8227597ac6c1dfee0aa8fbe7ba1da25cb39b170482",
      "label": "FrappeSnowland",
      "bundledPath": "map_names/FrappeSnowland.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/KalimariDesert.png",
      "object": "map_names/KalimariDesert.png",
      "generation": "1702951113500458",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 8162,
      "sha256": "1d12059cd4b96d3c38a9a747fcdb26782a2a1dda7aed612c63358dba60a81b04",
      "label": "KalimariDesert",
      "bundledPath": "map_names/KalimariDesert.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/KoopaTroopaBeach.png",
      "object": "map_names/KoopaTroopaBeach.png",
      "generation": "1702951112081964",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 8658,
      "sha256": "68355c831b3cad6dc998a0ff6127d7128961fa5bcb96e168f97f70110ef141a7",
      "label": "KoopaTroopaBeach",
      "bundledPath": "map_names/KoopaTroopaBeach.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/LuigiRaceway.png",
      "object": "map_names/LuigiRaceway.png",
      "generation": "1702951111579511",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7756,
      "sha256": "efa4ffc0783a46c35a90a209a81f9f75c95086ba8fc71a8b7dcceadb7e1b2bef",
      "label": "LuigiRaceway",
      "bundledPath": "map_names/LuigiRaceway.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/MarioRaceway.png",
      "object": "map_names/MarioRaceway.png",
      "generation": "1702951112626435",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 8371,
      "sha256": "8b3961c772d7a1d1f6818dd4dca810bb648d5caf4e8527cd77c3eec50c31eba2",
      "label": "MarioRaceway",
      "bundledPath": "map_names/MarioRaceway.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/MooMooFarm.png",
      "object": "map_names/MooMooFarm.png",
      "generation": "1702951112093035",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7302,
      "sha256": "44839ee3e7eaf9880d010a9c1d2ed060a07c03aa65390598e02ba396682627f9",
      "label": "MooMooFarm",
      "bundledPath": "map_names/MooMooFarm.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/RainbowRoad.png",
      "object": "map_names/RainbowRoad.png",
      "generation": "1702951111048788",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7999,
      "sha256": "aa74c463ce75be53fd5dc1208eeab8c1a1955f7f9703a384a1f5ec194be69f3f",
      "label": "RainbowRoad",
      "bundledPath": "map_names/RainbowRoad.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/RoyalRaceway.png",
      "object": "map_names/RoyalRaceway.png",
      "generation": "1702951114011461",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7524,
      "sha256": "a8769962d9db8a8cdcfbc79dc635ad0007ff9206543bd5a8cdd12851e6c4304c",
      "label": "RoyalRaceway",
      "bundledPath": "map_names/RoyalRaceway.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/SelectMap.png",
      "object": "map_names/SelectMap.png",
      "generation": "1705623793313142",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 6441,
      "sha256": "9b2443294bf1db8330783ff580a4f1aafcd410b4499b9aeb42c7fdeebf71beb0",
      "label": "SelectMap",
      "bundledPath": "map_names/SelectMap.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/SherbetLand.png",
      "object": "map_names/SherbetLand.png",
      "generation": "1702951112119095",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 6728,
      "sha256": "57991f680faa7f8814fc8a5af27e0792f2c1553d3bf3a6058614b04c719c619d",
      "label": "SherbetLand",
      "bundledPath": "map_names/SherbetLand.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/ToadsTurnpike.png",
      "object": "map_names/ToadsTurnpike.png",
      "generation": "1702951113016597",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7735,
      "sha256": "765f56fec2b186d6ab8de22338f21774fa0977365e1ed78bfb1a623571c3c518",
      "label": "ToadsTurnpike",
      "bundledPath": "map_names/ToadsTurnpike.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/WarioStadium.png",
      "object": "map_names/WarioStadium.png",
      "generation": "1702951112582009",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7979,
      "sha256": "15fe70e8c01f43899ab6c59f0be3e9dfdb7dfd06ac24fc8c48230b8ae2fa58f5",
      "label": "WarioStadium",
      "bundledPath": "map_names/WarioStadium.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "map_names/YoshiValley.png",
      "object": "map_names/YoshiValley.png",
      "generation": "1702951113570346",
      "width": 410,
      "height": 48,
      "contentType": "image/png",
      "bytes": 7031,
      "sha256": "72db2d03f5894fef727d5baa1885d9f2e5a9c2f5dfe7867a0a35fc40a26e8ed0",
      "label": "YoshiValley",
      "bundledPath": "map_names/YoshiValley.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/10_Sherbert_Land_MK64.webp",
      "object": "maps/10_Sherbert_Land_MK64.webp",
      "generation": "1702951117056789",
      "width": 146,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 8460,
      "sha256": "314f9b5b4445dd302a1047450cffb7359ace7c24a42a614ed0ff4da297e65f8b",
      "label": "10 Sherbert Land MK64",
      "bundledPath": "maps/10_Sherbert_Land_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/11_Royal_Raceway_MK64.webp",
      "object": "maps/11_Royal_Raceway_MK64.webp",
      "generation": "1702951117083078",
      "width": 146,
      "height": 91,
      "contentType": "image/webp",
      "bytes": 6946,
      "sha256": "7b55970214c8db70d575fa3067c27e158158d3f480b19ae6d019a4e1fc0b9201",
      "label": "11 Royal Raceway MK64",
      "bundledPath": "maps/11_Royal_Raceway_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/12_Bowser_Castle_MK64.webp",
      "object": "maps/12_Bowser_Castle_MK64.webp",
      "generation": "1702951117352330",
      "width": 146,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 9318,
      "sha256": "5e2ebcab15bd9e3ff0a587a81f024cb4fb146fdc9d3b4206f0994f6aa654a149",
      "label": "12 Bowser Castle MK64",
      "bundledPath": "maps/12_Bowser_Castle_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/13_DK_Jungle_Parkway_MK64.webp",
      "object": "maps/13_DK_Jungle_Parkway_MK64.webp",
      "generation": "1702951114531796",
      "width": 146,
      "height": 91,
      "contentType": "image/webp",
      "bytes": 10318,
      "sha256": "e2e7e0051ec77929780d4fb0552531096685ddff870c56bead6dfa81aeb857bd",
      "label": "13 DK Jungle Parkway MK64",
      "bundledPath": "maps/13_DK_Jungle_Parkway_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/14_Yoshi_Valley_MK64.webp",
      "object": "maps/14_Yoshi_Valley_MK64.webp",
      "generation": "1702951116342203",
      "width": 146,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 9278,
      "sha256": "b836dad559e45a58e124fc67c02ab90b50cec090f7fe0c709ca30b533a977046",
      "label": "14 Yoshi Valley MK64",
      "bundledPath": "maps/14_Yoshi_Valley_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/15_Banshee_Boardwalk_MK64.webp",
      "object": "maps/15_Banshee_Boardwalk_MK64.webp",
      "generation": "1702951115894754",
      "width": 145,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 7078,
      "sha256": "13f049d681e1a8b3f57a77a6a589016dec963085e82e8215d37f2704dc1ff4f6",
      "label": "15 Banshee Boardwalk MK64",
      "bundledPath": "maps/15_Banshee_Boardwalk_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/16_Rainbow-road-n64.webp",
      "object": "maps/16_Rainbow-road-n64.webp",
      "generation": "1702951116539573",
      "width": 146,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 6268,
      "sha256": "25344f776ee45e09c5e794a7deee9821e111a0a8898d52d8c9e88c5996376d52",
      "label": "16 Rainbow road n64",
      "bundledPath": "maps/16_Rainbow-road-n64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/1_Luigi_Raceway_MK64.png",
      "object": "maps/1_Luigi_Raceway_MK64.png",
      "generation": "1702951114536500",
      "width": 146,
      "height": 90,
      "contentType": "image/png",
      "bytes": 23052,
      "sha256": "c952d28e1dca71eb6649719027fc800d007418418acf12eddf1813640c8a536e",
      "label": "1 Luigi Raceway MK64",
      "bundledPath": "maps/1_Luigi_Raceway_MK64.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/2_Moo_Moo_Farm_MK64.webp",
      "object": "maps/2_Moo_Moo_Farm_MK64.webp",
      "generation": "1702951116031779",
      "width": 146,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 6608,
      "sha256": "8b254e521a1883dc6ddd54c23f0ebeba4df1b83280e33a33393ff0959baaff27",
      "label": "2 Moo Moo Farm MK64",
      "bundledPath": "maps/2_Moo_Moo_Farm_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/3_Koopa_Troopa _Beach_MK64.webp",
      "object": "maps/3_Koopa_Troopa _Beach_MK64.webp",
      "generation": "1702951115012490",
      "width": 146,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 6832,
      "sha256": "f7df0618c1f87b4fa281c13d7fa8d42e90b83e637872b7da9e324f65b7fbcbd0",
      "label": "3 Koopa Troopa  Beach MK64",
      "bundledPath": "maps/3_Koopa_Troopa _Beach_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/4_Kalimari_Desert_MK64.webp",
      "object": "maps/4_Kalimari_Desert_MK64.webp",
      "generation": "1702951115532029",
      "width": 145,
      "height": 89,
      "contentType": "image/webp",
      "bytes": 7576,
      "sha256": "6acec5ba826117be5f1cca1f5ddb40dbc3f6467adb7b7cfacaa10f51718d2736",
      "label": "4 Kalimari Desert MK64",
      "bundledPath": "maps/4_Kalimari_Desert_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/5_Toad's_Turnpike_MK64.webp",
      "object": "maps/5_Toad's_Turnpike_MK64.webp",
      "generation": "1702951115465862",
      "width": 145,
      "height": 88,
      "contentType": "image/webp",
      "bytes": 7738,
      "sha256": "a4aad7372c810d0293bdb8a6529816055065e615cc9d4baa842500b34373374d",
      "label": "5 Toad's Turnpike MK64",
      "bundledPath": "maps/5_Toad's_Turnpike_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/6_Frappe_Snowland_MK64.webp",
      "object": "maps/6_Frappe_Snowland_MK64.webp",
      "generation": "1702951117625738",
      "width": 144,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 7560,
      "sha256": "3dd951343ed0545c802f70e71ca50f270efa994dc6fcec478141da8ded8ab5a5",
      "label": "6 Frappe Snowland MK64",
      "bundledPath": "maps/6_Frappe_Snowland_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/7_Choco_Mountain_MK64.webp",
      "object": "maps/7_Choco_Mountain_MK64.webp",
      "generation": "1702951115130049",
      "width": 146,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 8788,
      "sha256": "bf016a854bb24bc6d7eaa33d0ee36c95f6bcca2465d3527fb9189e250a97c0be",
      "label": "7 Choco Mountain MK64",
      "bundledPath": "maps/7_Choco_Mountain_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/8_Mario_Raceway_MK64.webp",
      "object": "maps/8_Mario_Raceway_MK64.webp",
      "generation": "1702951116816771",
      "width": 146,
      "height": 90,
      "contentType": "image/webp",
      "bytes": 7458,
      "sha256": "734eef0b743a665c09733f4ee2a8593abdf90077207fb9d9ee0148d3bb8fd176",
      "label": "8 Mario Raceway MK64",
      "bundledPath": "maps/8_Mario_Raceway_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/9_Wario_Stadium_MK64.webp",
      "object": "maps/9_Wario_Stadium_MK64.webp",
      "generation": "1702951114050930",
      "width": 146,
      "height": 89,
      "contentType": "image/webp",
      "bytes": 8202,
      "sha256": "16083b6d709fa087651f282b9bae8ee4689845399a76b2b55415c0f9acd8a2fa",
      "label": "9 Wario Stadium MK64",
      "bundledPath": "maps/9_Wario_Stadium_MK64.webp",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "maps/NoMapSelected.png",
      "object": "maps/NoMapSelected.png",
      "generation": "1702951116000135",
      "width": 302,
      "height": 187,
      "contentType": "image/png",
      "bytes": 10604,
      "sha256": "a809bcf9462aeecadcd9f591c231a66997055bb1998ba20f0d337e6199cdd968",
      "label": "NoMapSelected",
      "bundledPath": "maps/NoMapSelected.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/GrandPrix.png",
      "object": "navigation/GrandPrix.png",
      "generation": "1702951121569622",
      "width": 647,
      "height": 100,
      "contentType": "image/png",
      "bytes": 28646,
      "sha256": "bdc44f1ce710018c7c156ec739bf565e86d0fb341fb9d7849c1fd6b74400aa1b",
      "label": "GrandPrix",
      "bundledPath": "navigation/GrandPrix.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/Hamburger.png",
      "object": "navigation/Hamburger.png",
      "generation": "1702951119613019",
      "width": 114,
      "height": 100,
      "contentType": "image/png",
      "bytes": 4238,
      "sha256": "337c34d7728c77a6af1f32b03ec14b5b7377d0d77581ed48023e8a41caa7d4e9",
      "label": "Hamburger",
      "bundledPath": "navigation/Hamburger.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/RaceEntry.png",
      "object": "navigation/RaceEntry.png",
      "generation": "1702951121101705",
      "width": 687,
      "height": 100,
      "contentType": "image/png",
      "bytes": 30112,
      "sha256": "c3cf56922aab8b5c94bffcf81bc6095a9d1de9aa1d4d1ef24f2b56704f28d8cd",
      "label": "RaceEntry",
      "bundledPath": "navigation/RaceEntry.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/Retire.png",
      "object": "navigation/Retire.png",
      "generation": "1702951120140712",
      "width": 219,
      "height": 59,
      "contentType": "image/png",
      "bytes": 10741,
      "sha256": "983381ea046edd66b59b5da3d4f827188c3acec6a430dd2c738ac54705a12417",
      "label": "Retire",
      "bundledPath": "navigation/Retire.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/Roster.png",
      "object": "navigation/Roster.png",
      "generation": "1705634491560044",
      "width": 452,
      "height": 100,
      "contentType": "image/png",
      "bytes": 20709,
      "sha256": "ab31a283a66bb8b2128f710d33f7a6133b0c5c8e23f427d11e83a6650924401f",
      "label": "Roster",
      "bundledPath": "navigation/Roster.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/ShowScores.png",
      "object": "navigation/ShowScores.png",
      "generation": "1730512418660827",
      "width": 1024,
      "height": 219,
      "contentType": "image/png",
      "bytes": 79720,
      "sha256": "88ce57f6044a1c6d0cfd9413aa71a54a70380271060e81f58af2cb4036dd8790",
      "label": "ShowScores",
      "bundledPath": "navigation/ShowScores.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/SignIn.png",
      "object": "navigation/SignIn.png",
      "generation": "1702951121617819",
      "width": 409,
      "height": 100,
      "contentType": "image/png",
      "bytes": 21318,
      "sha256": "d8800b58aea9f95a23212c757d91d87b028e244a5d2c107eef58f74f4b1a03fc",
      "label": "SignIn",
      "bundledPath": "navigation/SignIn.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/Skip.png",
      "object": "navigation/Skip.png",
      "generation": "1702951119730349",
      "width": 144,
      "height": 60,
      "contentType": "image/png",
      "bytes": 9384,
      "sha256": "22cabeeb2629c29a9b16a797fa97b1af6080946eaaa97964585786029c848724",
      "label": "Skip",
      "bundledPath": "navigation/Skip.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/Stats.png",
      "object": "navigation/Stats.png",
      "generation": "1702951120631985",
      "width": 386,
      "height": 100,
      "contentType": "image/png",
      "bytes": 18095,
      "sha256": "e193e7e24ab7ab8642dc8481c1ff7b94545483f2b297bb618a002bfb00b17dbd",
      "label": "Stats",
      "bundledPath": "navigation/Stats.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "navigation/Submit.png",
      "object": "navigation/Submit.png",
      "generation": "1702951120183625",
      "width": 426,
      "height": 100,
      "contentType": "image/png",
      "bytes": 18010,
      "sha256": "cc352755b2c687f0220c389a7d8e3a699f3caedf735d60fc85e0ed9a9086b94e",
      "label": "Submit",
      "bundledPath": "navigation/Submit.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "ranks/1st.png",
      "object": "ranks/1st.png",
      "generation": "1730578267716817",
      "width": 1005,
      "height": 523,
      "contentType": "image/png",
      "bytes": 63854,
      "sha256": "93bb53f0418403400912a508132c68cba24a5f61739f1fbb455b6ef87e64a844",
      "label": "1st",
      "bundledPath": "ranks/1st.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "ranks/2nd.png",
      "object": "ranks/2nd.png",
      "generation": "1730578267789550",
      "width": 1024,
      "height": 466,
      "contentType": "image/png",
      "bytes": 84278,
      "sha256": "2a611d6ef0fe3015107476af5c4abdb48c8e2c5991e602c188ba7a45c0fdfbab",
      "label": "2nd",
      "bundledPath": "ranks/2nd.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "ranks/3rd.png",
      "object": "ranks/3rd.png",
      "generation": "1730578267787793",
      "width": 1024,
      "height": 497,
      "contentType": "image/png",
      "bytes": 87905,
      "sha256": "e58a85250a6977d25e0a0e0202f1b5e126382579cf659f46c0a080e6655c3d7a",
      "label": "3rd",
      "bundledPath": "ranks/3rd.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "ranks/4th.png",
      "object": "ranks/4th.png",
      "generation": "1730578313092784",
      "width": 1024,
      "height": 493,
      "contentType": "image/png",
      "bytes": 83975,
      "sha256": "c583710180a13000a025b55b9c719efe225c8794fb6bb57d1a962198c28ed155",
      "label": "4th",
      "bundledPath": "ranks/4th.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "ranks/5th.png",
      "object": "ranks/5th.png",
      "generation": "1730582228690759",
      "width": 1024,
      "height": 503,
      "contentType": "image/png",
      "bytes": 82950,
      "sha256": "7d781401b6648533d88d332b45f8092706af57a5d3c78a115cccc0f8f585171d",
      "label": "5th",
      "bundledPath": "ranks/5th.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "ranks/6th.png",
      "object": "ranks/6th.png",
      "generation": "1730582228336471",
      "width": 1023,
      "height": 491,
      "contentType": "image/png",
      "bytes": 70637,
      "sha256": "f4f708ef1a052f979f9d429aa7f1273fd5fcdc944d6f4b87c05905f8b0257a69",
      "label": "6th",
      "bundledPath": "ranks/6th.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "ranks/7th.png",
      "object": "ranks/7th.png",
      "generation": "1730582228268328",
      "width": 1024,
      "height": 505,
      "contentType": "image/png",
      "bytes": 67908,
      "sha256": "d2bf6e0c7b50c18560a9331056595760cf556a448bc869358797cef086737cd9",
      "label": "7th",
      "bundledPath": "ranks/7th.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "ranks/8th.png",
      "object": "ranks/8th.png",
      "generation": "1730582228263834",
      "width": 1024,
      "height": 497,
      "contentType": "image/png",
      "bytes": 71980,
      "sha256": "8245f6e3c8707bea9520362329c5701ac9a53cb6a691feb3d83898eefece5d3a",
      "label": "8th",
      "bundledPath": "ranks/8th.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/Beeg_Yoshi.png",
      "object": "roster_characters/Beeg_Yoshi.png",
      "generation": "1726883454851595",
      "width": 102,
      "height": 102,
      "contentType": "image/png",
      "bytes": 15177,
      "sha256": "6d3e013dc5f3b0830f329a5f20af43371757af2230296944f9f22725a23b2744",
      "label": "Beeg Yoshi",
      "bundledPath": "roster_characters/Beeg_Yoshi.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/Bowser_portrait.png",
      "object": "roster_characters/Bowser_portrait.png",
      "generation": "1726883455154499",
      "width": 102,
      "height": 102,
      "contentType": "image/png",
      "bytes": 20223,
      "sha256": "2738a4fa9e34fddbb2f6ddc2950f3c02b62f6f135a8c633550251cffeb7fc80f",
      "label": "Bowser portrait",
      "bundledPath": "roster_characters/Bowser_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/DK_portrait.png",
      "object": "roster_characters/DK_portrait.png",
      "generation": "1726883454077770",
      "width": 101,
      "height": 102,
      "contentType": "image/png",
      "bytes": 15451,
      "sha256": "8115713d3c8d7ba4275a3ff00c7ee53b4b850d238e5e90ec9154ff9c0975eccd",
      "label": "DK portrait",
      "bundledPath": "roster_characters/DK_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/Luigi_portrait.png",
      "object": "roster_characters/Luigi_portrait.png",
      "generation": "1726883454154460",
      "width": 102,
      "height": 103,
      "contentType": "image/png",
      "bytes": 12301,
      "sha256": "faa86ce5cbe1c50540d79153326675e170cba5bfed8f2ac4b43255606ef52f3c",
      "label": "Luigi portrait",
      "bundledPath": "roster_characters/Luigi_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/Mario_portrait.png",
      "object": "roster_characters/Mario_portrait.png",
      "generation": "1726883454088167",
      "width": 101,
      "height": 102,
      "contentType": "image/png",
      "bytes": 12440,
      "sha256": "7a256500a015c75a90e2f7037b5bff92a8d263ab5cf1f696c580317b88a68ad4",
      "label": "Mario portrait",
      "bundledPath": "roster_characters/Mario_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/Peach_portrait.png",
      "object": "roster_characters/Peach_portrait.png",
      "generation": "1726883454412175",
      "width": 101,
      "height": 102,
      "contentType": "image/png",
      "bytes": 14920,
      "sha256": "ed8f8e08f5336b1aa3ca98ef6978096009f668e3510f378f0204e232d7093144",
      "label": "Peach portrait",
      "bundledPath": "roster_characters/Peach_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/Toad_portrait.png",
      "object": "roster_characters/Toad_portrait.png",
      "generation": "1726883454479655",
      "width": 101,
      "height": 102,
      "contentType": "image/png",
      "bytes": 9460,
      "sha256": "59837db83164a147fac2a829e2d5e72c8c31842c444dacc02e6ba3d9264bd22f",
      "label": "Toad portrait",
      "bundledPath": "roster_characters/Toad_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/Wario_portrait.png",
      "object": "roster_characters/Wario_portrait.png",
      "generation": "1726883454787872",
      "width": 102,
      "height": 102,
      "contentType": "image/png",
      "bytes": 18941,
      "sha256": "5a55bc5a4a343ef76c14b501b649c0e7145bed9c5adb61cd5e2f30e867c5ed17",
      "label": "Wario portrait",
      "bundledPath": "roster_characters/Wario_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    },
    {
      "id": "roster_characters/Yoshi_portrait.png",
      "object": "roster_characters/Yoshi_portrait.png",
      "generation": "1726883454851533",
      "width": 102,
      "height": 102,
      "contentType": "image/png",
      "bytes": 10039,
      "sha256": "3de8653e60dddbb65cbb9d6a4964c3d9e1684f3f94b6da3cd2fa9df9e8805fe1",
      "label": "Yoshi portrait",
      "bundledPath": "roster_characters/Yoshi_portrait.png",
      "fallbackPath": "fallbacks/artwork.svg"
    }
  ]
};
